import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/gateway/:gatewayId/start-streaming/`;

type StartCameraWebRTCDTO = {
    gatewayId: string;
    parkingId: string;
    /** The WebRTC SDP offer as plain SDP text — not base64. */
    sdp: string;
};

type StartCameraWebRTCResponse = {
    /** The WebRTC SDP answer as plain SDP text — not base64. */
    sdp: string;
};

export const startCameraWebRTC = async ({
    gatewayId,
    parkingId,
    ...data
}: StartCameraWebRTCDTO): Promise<StartCameraWebRTCResponse> => {
    return await axios.post(formatResourcePath(RESOURCE, { gatewayId, parkingId }), data);
};

type StartCameraWebRTCFnType = typeof startCameraWebRTC;

export const useCameraStreamStart = (options: MutationConfig<StartCameraWebRTCFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn: startCameraWebRTC,
        ...options,
    });
